import { Locales } from '@/i18n/i18n-types';
import { DateTime } from 'luxon';
import { clsx, type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export function getLuxonLocale(i18nLocale: Locales): string {
  return {
    en: 'en-US',
    pt: 'pt-BR',
  }[i18nLocale];
}

/** Numeric date + 24h time; day/month order follows locale (e.g. pt-BR dd/mm/yyyy, en-US mm/dd/yyyy). */
export function formatShortDateTime(iso: string, i18nLocale: Locales): string {
  return DateTime.fromISO(iso)
    .setLocale(getLuxonLocale(i18nLocale))
    .toLocaleString({
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit',
      hour12: false,
    });
}

export function isVersionGreaterOrEqual(
  version1: string,
  version2: string
): boolean {
  const parts1 = version1.split('.').map(Number);
  const parts2 = version2.split('.').map(Number);

  const maxLength = Math.max(parts1.length, parts2.length);
  while (parts1.length < maxLength) parts1.push(0);
  while (parts2.length < maxLength) parts2.push(0);

  for (let i = 0; i < maxLength; i++) {
    if (parts1[i] > parts2[i]) return true;
    if (parts1[i] < parts2[i]) return false;
  }

  return true; // versions are equal
}
